<template>
  <div>
    <transition
      enter-active-class="duration-300"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-300"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <pe-alert v-if="showAlert && result.$invalid" type="danger" unclosable>
        Confira o(s) erro(s) no formulário
        <ul v-if="listErrors && result.$messages.length > 0" class="m-0 p-0">
          <li v-for="(msg, index) in result.$messages" :key="index" class="ml-6 list-disc">
            {{ msg }}
          </li>
        </ul>
      </pe-alert>
    </transition>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, nextTick, watchEffect } from 'vue'
import useValidate from 'vue-tiny-validate'

const props = defineProps<{
  formData?: any
  rules?: any
  autoValidate?: boolean
  showAlert?: boolean
  listErrors?: boolean
  noToast?: boolean
}>()

const options = ref({
  autoTest: false
})

watchEffect(() => {
  if (props.autoValidate) options.value.autoTest = props.autoValidate
})

const { result } = useValidate(props.formData, props.rules, options)
const silent = ref(false)

const validate = () => { 
  result.value.$test()

  return !result.value.$invalid
}

defineExpose({
  validate,
  resetValidate: () => {
    silent.value = true
    result.value.$reset()
    nextTick(() => silent.value = false)
  },
  invalid: computed(() => result.value.$invalid),
  getErrors: (prop?: string) => (prop ? result.value[prop].$messages : result.value.$messages),
  getCurrentError: (prop?: string) => (prop ? result.value[prop]?.$messages[0] : result.value?.$messages[0]) || '',
  hasError: (prop?: string) => (prop ? result.value[prop].$invalid : result.value.$invalid)
})
</script>
